export type ManifestCompatibility = {
  device_name_prefix?: string;
  hw_revs?: string[];
  ota_protocol?: string;
};

export type ManifestUpdate = {
  version: string;
  tag: string;
  date: string;
  compat: ManifestCompatibility;
  min_boot: string;
  url: string;
  size: number;
  sha256: string;
  release_notes: string;
  release_url?: string;
};

export type Manifest = {
  schema_version: number;
  generated_at: string;
  channel: string;
  updates: ManifestUpdate[];
};

export function isManifest(data: unknown): data is Manifest {
  if (!data || typeof data !== 'object') {
    return false;
  }
  const record = data as Record<string, unknown>;
  if (typeof record.schema_version !== 'number') {
    return false;
  }
  if (typeof record.generated_at !== 'string') {
    return false;
  }
  if (typeof record.channel !== 'string') {
    return false;
  }
  if (!Array.isArray(record.updates)) {
    return false;
  }
  return true;
}
